import { IReportingPeriodApplicantDocumentService } from "../../service/document/ReportingPeriodApplicantDocumentService";

export default class RemoveReportingPeriodApplicantDocumentInteractor {
  private reportingPeriodApplicantDocumentService: IReportingPeriodApplicantDocumentService;

  constructor(reportingPeriodApplicantDocumentService) {
    this.reportingPeriodApplicantDocumentService = reportingPeriodApplicantDocumentService;
  }

  async execute(reportingPeriodApplicantId: number, documentId: number) {
    return this.reportingPeriodApplicantDocumentService.removeReportingPeriodApplicantDocument(
      reportingPeriodApplicantId,
      documentId
    );
  }
}
